import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useStats } from '../contexts/StatsContext';
import { getSiteName, getLogo } from '../utils/config';

function Header() {
  const [keyword, setKeyword] = useState('');
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();
  const stats = useStats();
  const siteName = getSiteName() || '盘搜';
  const logo = getLogo() || '/images/logo.png';

  const handleSearch = () => {
    if (!keyword.trim()) return;
    // 直接跳转到搜索结果页，带上搜索参数
    navigate(`/search?keyword=${encodeURIComponent(keyword.trim())}&page=1&limit=8&category=`);
  };

  const handleKeyPress = (e) => {
    if (e.key === 'Enter') {
      handleSearch();
    }
  };

  return (
    <header className="header-wrapper">
      <div className="container">
        <div className="logo-section">
          <img 
            src={logo} 
            alt={siteName}
            className="site-logo" 
          />
        </div>
        
        <div className="search-box">
          <input 
            type="text" 
            className="search-input" 
            placeholder="搜索你想要的资源..." 
            value={keyword}
            onChange={(e) => setKeyword(e.target.value)}
            onKeyPress={handleKeyPress}
          />
          <button 
            className="search-button" 
            onClick={handleSearch}
            disabled={loading}
          >
            <i className="search-icon">🔍</i>
          </button>
        </div>

        {stats && (
          <div className="search-stats">
            {siteName}是专业的综合云盘搜索引擎，搜索一下试试看。今日收录
            <span className="highlight-number">{stats.today_new}</span>
            条
          </div>
        )}
      </div>
    </header>
  );
}

export default Header;